import { registerType } from '../types'

interface TextAreaInterface {
  name: string
  id: string
  register: Function
  registerOptions?: registerType
  assistiveText?: string
  errorMessage?: string
  type?: string
  label?: string
  defaultValue?: string
}
export default function TextArea({
  assistiveText,
  name,
  id,
  label,
  errorMessage,
  register,
  registerOptions,
  defaultValue
}: TextAreaInterface) {
  const inputClass = errorMessage ? 'wc-textarea input-validation-error' : 'wc-textarea'
  return (
    <div className="wc-form-item">
      <label htmlFor={id} className="label-primary">
        {label}
      </label>
      {assistiveText && <span className="wc-assist">{assistiveText}</span>}
      {errorMessage && (
        <span
          className="field-validation-error wc-assist wc-assist--error"
          role="alert"
        >
          {errorMessage}
        </span>
      )}
      <textarea
        id={id}
        name={name}
        className={inputClass}
        defaultValue={defaultValue}
        {...register(name, registerOptions)}
      />
    </div>
  )
}
